module.exports = __webpack_public_path__ + "static/media/bulk_credit_transit.e970139b.csv";